import { Empty, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import {
  getCustomerDissatisfactionOperationalSignalColor,
  getCustomerDissatisfactionOperationalSignalLabel,
} from "../../../models/customer-satisfaction/enum";

interface IProps {
  signals?: (string | { key?: string | null; label?: string | null })[];
  emptyTextKey?: string;
  size?: "small" | "default";
}

const normalizeSignalKey = (
  signal?: string | { key?: string | null; label?: string | null } | null,
) => (typeof signal === "string" ? signal : signal?.key);

const OperationalSignalTags: React.FC<IProps> = ({
  signals,
  emptyTextKey = "unclassified_operationally",
  size = "default",
}) => {
  const { t } = useTranslation();
  const normalized = (signals || []).map(normalizeSignalKey).filter(Boolean);

  if (normalized.length === 0) {
    return size === "small" ? (
      <Tag>{t(emptyTextKey)}</Tag>
    ) : (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t(emptyTextKey)} />
    );
  }

  return (
    <Space size={[4, 4]} wrap>
      {normalized.map((signal) => (
        <Tag
          key={signal}
          color={getCustomerDissatisfactionOperationalSignalColor(signal)}
        >
          {t(getCustomerDissatisfactionOperationalSignalLabel(signal))}
        </Tag>
      ))}
    </Space>
  );
};

export default OperationalSignalTags;
